import React from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  ButtonGroup,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { getTranslate } from "react-localize-redux";
import moment from "moment";
import { Pie, Line } from "react-chartjs-2";
import { actions } from "react-redux-form";

import { SearchPanel } from "../AppLayout/SearchPanel/SearchPanel";
import { dashboardActions, msgActions } from "../../../redux/actions";

import "./Dashboard.css";

let dynamicallyColorAssignedList = [];

class Dashboard extends React.Component {
  state = {
    channelsDetailsModal: false,
  };
  componentDidMount() {
    const { dispatch, dashboard, dashboardSearch } = this.props;
    if (!dashboard.loading && !dashboard.widgets) {
      dispatch(dashboardActions.getLayout(getSearchingData(dashboardSearch)));
    }
  }

  handleParamChange = (paramName, paramValue) => {
    this.props.dispatch(
      actions.change(`dashboardSearch.${paramName}`, paramValue)
    );
  };

  handleSearchClick = () => {
    const { dispatch, dashboard, dashboardSearch } = this.props;
    if (!dashboard.loading) {
      if (dashboardSearch.Start && dashboardSearch.End) {
        dispatch(
          dashboardActions.getLayout(
            getSearchingData(dashboardSearch),
            dashboard
          )
        );
      } else {
        // show error
        dispatch(
          msgActions.error(
            "Invalid Search parameters",
            "ParameterMissingStartEnd"
          )
        );
      }
    }
  };

  onPeriodRadioBtnClick = (widgetId, rSelect) => {
    const { dispatch, dashboardSearch } = this.props;
    let _params = getSearchingData(dashboardSearch);
    dispatch(
      dashboardActions.getWedgetData({
        ..._params,
        WidgetId: widgetId,
        Granularity: rSelect,
      })
    );
  };

  showMore = () => {
    this.setState({
      channelsDetailsModal: true,
    });
  };

  getChannelDetailComponent = () => {
    const { dashboard } = this.props;
    let _comResult = [];
    if (
      dashboard.widgets &&
      dashboard.widgets.rows &&
      dashboard.widgets.rows.length
    ) {
      dashboard.widgets.rows.forEach((row) => {
        row.forEach((widget) => {
          if (
            widget.WidgetType === "pie" &&
            widget.WidgetId === "WidgetChannelVolumesPie"
          ) {
            var _data = {};
            if (widget.data && widget.data.length) {
              var _labels = [],
                _bgColors = [],
                _values = [];
              widget.data.forEach((item, itIndex) => {
                _labels.push(item.category);
                if (!_bgColors.includes(item.color)) {
                  _bgColors.push(item.color);
                } else {
                  // check first on the dynamicallyColorAssignedList global variable for the same category
                  var _obj = dynamicallyColorAssignedList.find(
                    (o) => o.item === item.category
                  );
                  if (_obj) {
                    _bgColors.push(_obj.color);
                  } else {
                    var _newColor = dynamicColors();
                    dynamicallyColorAssignedList.push({
                      item: item.category,
                      color: _newColor,
                    });
                    _bgColors.push(_newColor);
                  }
                }
                _values.push(item.value);
              });
            }
            _data = {
              labels: _labels,
              datasets: [
                {
                  data: _values,
                  backgroundColor: _bgColors,
                },
              ],
            };
            _comResult.push(
              <div
                className="chart_widget"
                style={{
                  borderRadius: "8px",
                  backgroundColor: "white",
                  padding: "10px",
                }}
                key={widget.WidgetId}
                data-type={widget.WidgetType}
                data-title={widget.Title}
              >
                <div className="d-flex flex-row" style={{ width: "100%" }}>
                  <Pie
                    data={_data}
                    height={640}
                    options={{
                      maintainAspectRatio: false,
                    }}
                  />
                </div>
              </div>
            );
          }
        });
      });
    }
    return _comResult;
  };

  getLayoutComponent = () => {
    const { dashboard, translate } = this.props;
    var me = this;
    var _content = [];
    if (
      dashboard.widgets &&
      dashboard.widgets.rows &&
      dashboard.widgets.rows.length
    ) {
      dashboard.widgets.rows.forEach((row, indx) => {
        row.forEach((widget, index) => {
          if (widget.WidgetType === "pie" || widget.WidgetType === "line") {
            var chartComp = null;
            let legend = {
              display: true,
            };
            let showMore = false;
            if (widget.WidgetType === "pie") {
              var _data = {};
              if (widget.data && widget.data.length) {
                var _labels = [],
                  _bgColors = [],
                  _values = [];

                widget.data.forEach((item, itIndex) => {
                  _labels.push(item.category);
                  if (!_bgColors.includes(item.color)) {
                    _bgColors.push(item.color);
                  } else {
                    // check first on the dynamicallyColorAssignedList global variable for the same category
                    var _obj = dynamicallyColorAssignedList.find(
                      (o) => o.item === item.category
                    );
                    if (_obj) {
                      _bgColors.push(_obj.color);
                    } else {
                      var _newColor = dynamicColors();
                      dynamicallyColorAssignedList.push({
                        item: item.category,
                        color: _newColor,
                      });
                      _bgColors.push(_newColor);
                    }
                  }
                  _values.push(item.value);
                });
                if (
                  widget.WidgetId === "WidgetChannelVolumesPie" &&
                  widget.data.length > 5
                ) {
                  showMore = true;
                  legend["labels"] = {
                    generateLabels: (chart) => {
                      var data = chart.data;
                      var meta = null;
                      try {
                        meta = chart.getDatasetMeta(0);
                      } catch (error) {}
                      var ds = data.datasets[0];
                      let _tempValues = _values.slice(0);
                      var topValues = _tempValues
                        .sort((a, b) => b - a)
                        .slice(0, 5);
                      let topIndexes = [];
                      topValues.forEach((element) => {
                        topIndexes.push(_values.indexOf(element));
                      });
                      let _res = [];
                      let _hidden = false;
                      if (!!meta && !!ds) {
                        _hidden =
                          isNaN(ds.data[index]) || meta.data[index].hidden;
                      }
                      topIndexes.forEach((index) => {
                        _res.push({
                          text: _labels[index],
                          fillStyle: _bgColors[index],
                          strokeStyle: _bgColors[index],
                          hidden: _hidden,
                          datasetIndex: index,
                          index: index,
                        });
                      });
                      return _res;
                    },
                  };
                }
                _data = {
                  labels: _labels,
                  datasets: [
                    {
                      data: _values,
                      backgroundColor: _bgColors,
                    },
                  ],
                };
              }
              chartComp = (
                <div
                  className="chartHeight chart_widget"
                  style={{
                    borderRadius: "8px",
                    backgroundColor: "white",
                    padding: "10px",
                    position: "relative",
                  }}
                  id={widget.WidgetId}
                  data-type={widget.WidgetType}
                  data-title={widget.Title}
                >
                  <strong>{widget.Title}</strong>
                  <div className="d-flex flex-row" style={{ width: "100%" }}>
                    {widget.loading && (
                      <div className="chart-loader">
                        <div
                          className="lds-spinner"
                          style={{ top: "0px", marginTop: "70px" }}
                        >
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                        </div>
                        <div
                          className="lds-text"
                          style={{ top: "0px", width: "100%" }}
                        >
                          loading data...
                        </div>
                      </div>
                    )}
                    <Pie
                      data={_data}
                      height={340}
                      options={{
                        maintainAspectRatio: false,
                        legend,
                      }}
                    />
                    {showMore && (
                      <button
                        style={{
                          margin: "5px",
                          position: "absolute",
                          bottom: 0,
                          right: 0,
                        }}
                        type="button"
                        className="btn btn-secondary btn-sm"
                        onClick={this.showMore}
                      >
                        {translate("Show details")}
                      </button>
                    )}
                  </div>
                </div>
              );
            } else {
              let _dataLine = {};
              if (widget.data) {
                var _lineLabels = widget.data.categories,
                  _datasets = [],
                  _chartdata = widget.data.chartdata,
                  _tempColors = [];

                (widget.data.series || []).forEach((field, fIndex) => {
                  var _fieldData = [];
                  _chartdata.forEach((cData, cDIndex) => {
                    _fieldData.push(cData[field.field]);
                  });

                  var _color = field.color;
                  if (!_tempColors.includes(_color)) {
                    _tempColors.push(_color);
                  } else {
                    var _obj = dynamicallyColorAssignedList.find(
                      (o) => o.item === field.name
                    );
                    if (_obj) {
                      _tempColors.push(_obj.color);
                      _color = _obj.color;
                    } else {
                      var _newColor = dynamicColors();
                      dynamicallyColorAssignedList.push({
                        item: field.name,
                        color: _newColor,
                      });
                      _tempColors.push(_newColor);
                      _color = _newColor;
                    }
                  }

                  _datasets.push({
                    label: field.name,
                    fill: false,
                    lineTension: 0.1,
                    borderWidth: 2,
                    backgroundColor: _color,
                    borderColor: _color,
                    borderCapStyle: "butt",
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: "miter",
                    pointBorderColor: _color,
                    pointBackgroundColor: "#fff",
                    pointBorderWidth: 2,
                    pointHoverRadius: 3,
                    pointHoverBackgroundColor: _color,
                    pointHoverBorderWidth: 3,
                    pointRadius: 4,
                    pointHitRadius: 5,
                    data: _fieldData,
                  });
                });
                _dataLine = {
                  labels: _lineLabels,
                  datasets: _datasets,
                };
              }
              chartComp = (
                <div
                  className="chartHeight chart_widget"
                  style={{
                    borderRadius: "8px",
                    backgroundColor: "white",
                    padding: "10px",
                  }}
                  id={widget.WidgetId}
                  data-type={widget.WidgetType}
                  data-title={widget.Title}
                >
                  <div
                    style={{ padding: "0 20px 7px" }}
                    className="d-flex justify-content-between"
                  >
                    <div style={{ width: "100%", textAlign: "center" }}>
                      <strong>{widget.Title}</strong>
                    </div>
                    <ButtonGroup>
                      <Button
                        onClick={() =>
                          me.onPeriodRadioBtnClick(widget.WidgetId, "d")
                        }
                        active={widget.granularity === "d"}
                      >
                        {translate("Days")}
                      </Button>
                      <Button
                        onClick={() =>
                          me.onPeriodRadioBtnClick(widget.WidgetId, "w")
                        }
                        active={
                          !widget.granularity || widget.granularity === "w"
                        }
                      >
                        {translate("Weeks")}
                      </Button>
                      <Button
                        onClick={() =>
                          me.onPeriodRadioBtnClick(widget.WidgetId, "m")
                        }
                        active={widget.granularity === "m"}
                      >
                        {translate("Months")}
                      </Button>
                    </ButtonGroup>
                  </div>
                  <div className="d-flex flex-row" style={{ width: "100%" }}>
                    {widget.loading && (
                      <div className="chart-loader">
                        <div
                          className="lds-spinner"
                          style={{ top: "0px", marginTop: "70px" }}
                        >
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                        </div>
                        <div
                          className="lds-text"
                          style={{ top: "0px", width: "100%" }}
                        >
                          loading data...
                        </div>
                      </div>
                    )}
                    <Line
                      data={_dataLine}
                      height={340}
                      options={{
                        maintainAspectRatio: false,
                      }}
                    />
                  </div>
                </div>
              );
            }
            if (widget.Colspan === 1) {
              _content.push(
                <div
                  key={indx + "-" + index}
                  className="flow col-lg-4 col-md-4 col-sm-12 col-xs-12 search-query widget-colspan1"
                >
                  {chartComp}
                </div>
              );
            } else if (widget.Colspan === 2) {
              _content.push(
                <div
                  key={indx + "-" + index}
                  className="flow col-lg-8 col-md-8 col-sm-12 col-xs-12 search-query widget-colspan1"
                >
                  {chartComp}
                </div>
              );
            }
          }
        });
      });
    }
    return <div id="charts">{_content}</div>;
  };

  toggleChannelsDetailsModal = () => {
    this.setState({
      channelsDetailsModal: !this.state.channelsDetailsModal,
    });
  };

  render() {
    const { dashboardSearch } = this.props;

    return (
      <div id="dashboard_view">
        <div className="w-100 top_search" style={{ textAlign: "center" }}>
          <SearchPanel
            view="dashboardView"
            searchParams={dashboardSearch}
            isExternalUser={this.props.isExternalUser}
            handleParamChange={this.handleParamChange}
            onSearchClick={(params_) => {
              this.handleSearchClick(params_);
            }}
          />
        </div>
        <div
          id="dashboard_content"
          className="content_block fill col-lg-12 col-md-12 col-sm-12 col-xs-12"
        >
          {this.getLayoutComponent()}
        </div>
        <Modal
          style={{ maxWidth: "95vw" }}
          isOpen={this.state.channelsDetailsModal}
          toggle={this.toggleChannelsDetailsModal}
        >
          <ModalHeader toggle={this.toggleChannelsDetailsModal}>
            Channels Chart Details
          </ModalHeader>
          <ModalBody>{this.getChannelDetailComponent()}</ModalBody>

          <ModalFooter>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.toggleChannelsDetailsModal}
            >
              {this.props.translate("Close")}
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

function getSearchingData(params) {
  var paramsObj = {};
  if (params.Start) {
    paramsObj["Start"] = moment
      .utc(params.Start)
      .format("YYYY-MM-DDTHH:mm:ss.SSS");
  }
  if (params.End) {
    paramsObj["End"] = moment.utc(params.End).format("YYYY-MM-DDTHH:mm:ss.SSS");
  }
  if (params.CustomerId) {
    paramsObj["CustomerId"] = params.CustomerId;
  }
  if (params.ProjectId) {
    paramsObj["ProjectId"] = params.ProjectId;
  }
  return paramsObj;
}

function dynamicColors() {
  var r = Math.floor(Math.random() * 255);
  var g = Math.floor(Math.random() * 255);
  var b = Math.floor(Math.random() * 255);
  return "rgb(" + r + "," + g + "," + b + ")";
}

function mapStateToProps(state) {
  const { dashboard, dashboardSearch, locale, loaderMask } = state;
  return {
    dashboard,
    dashboardSearch,
    loaderMask,
    translate: getTranslate(locale),
  };
}

const connectedDashboard = connect(mapStateToProps)(withRouter(Dashboard));
export { connectedDashboard as Dashboard };
